/* Copyright (c) 2026 Health Endeavors, LLC. All Rights Reserved */

import { Outlet } from 'react-router-dom';

import Loading from './Loading';
import { selectLogin } from './userSlice';
import { useAppSelector } from '../../../app/hooks';
import { useAuth } from './useHooks';
import { getSmartFhirCookieData } from '../Epic/smartFhirUtils';
import { getShareVueCookieData } from '../ShareVue/ShareVueUtils';
import { useEffect } from 'react';

export const RequiredAuth = ({ ready }: { ready: boolean }) => {
  const { authState, login } = useAuth();
  const loginDetails = useAppSelector(selectLogin);
  const smartFhirCookieData = getSmartFhirCookieData();
  const shareVueCookieData = getShareVueCookieData();

  useEffect(() => {
    if (authState && !authState.isAuthenticated && !authState.isPending) {
      /*
        When we first load the app and are logged out, authState is set but authState.isAuthenticated is false.
        In this case, we want to login.

        But when we get redirected back to the app after logging in, authState.isAuthenticated is still false,
        until we call isAuthenticated() on the oktaAuth object. So we need to call login(false) to do that.
       */
      void login(false);
    }
  }, [authState, login]);

  if (smartFhirCookieData?.error || shareVueCookieData?.error) {
    return null;
  }

  if (authState && !authState.isAuthenticated) {
    return <Loading />;
  }

  if (!ready && !loginDetails.errors) {
    /* We have not fetched oktaUserInfo yet */
    return <Loading />;
  }

  return <Outlet />;
};
